<template>
  <div>
    {{ getDate(orderData) | moment('YYYY-MM-DD hh:mm A') }}
    <div class="date-content">
      <div class="popover-arrow">&nbsp;</div>
      <div class="d-flex my-1">
        <div style="width: 40%">Order Date</div>
        <div>{{ orderData.order_date ? orderData.order_date : orderData.created_at }}</div>
      </div>

      <div
        v-if="orderData.process_date"
        class="d-flex my-1"
      >
        <div style="width: 40%">Process Date</div>
        <div>{{ orderData.process_date | moment('YYYY-MM-DD hh:mm A') }}</div>
      </div>

      <div
        v-if="orderData.cancel_date"
        class="d-flex my-1"
      >
        <div style="width: 40%">Cancel Date</div>
        <div>{{ orderData.cancel_date | moment('YYYY-MM-DD hh:mm A') }}</div>
      </div>

      <div
        v-if="orderData.confirm_date"
        class="d-flex my-1"
      >
        <div style="width: 40%">Approve Date</div>
        <div>{{ orderData.confirm_date | moment('YYYY-MM-DD hh:mm A') }}</div>
      </div>

      <div
        v-if="orderData.refund_date"
        class="d-flex my-1"
      >
        <div style="width: 40%">Refund Date</div>
        <div>{{ orderData.refund_date | moment('YYYY-MM-DD hh:mm A') }}</div>
      </div>

      <div
        v-if="orderData.purchase_date"
        class="d-flex my-1"
      >
        <div style="width: 40%">Purchase Date</div>
        <div>{{ orderData.purchase_date | moment('YYYY-MM-DD hh:mm A') }}</div>
      </div>

      <div
        v-if="orderData.warehouse_deliver_date"
        class="d-flex my-1"
      >
        <div style="width: 40%">Warehouse Date</div>
        <div>{{ orderData.warehouse_deliver_date | moment('YYYY-MM-DD hh:mm A') }}</div>
      </div>

      <div
        v-if="orderData.int_shipment_date"
        class="d-flex my-1"
      >
        <div style="width: 40%">Shipment Date</div>
        <div>{{ orderData.int_shipment_date | moment('YYYY-MM-DD hh:mm A') }}</div>
      </div>

      <div
        v-if="orderData.pending_to_branch_at"
        class="d-flex my-1"
      >
        <div style="width: 40%">
          <div>Pending To</div>
          <div>Branch Date</div>
        </div>
        <div class="pt-3">{{ orderData.pending_to_branch_at | moment('YYYY-MM-DD hh:mm A') }}</div>
      </div>

      <div
        v-if="orderData.branch_delivery_date"
        class="d-flex my-1"
      >
        <div style="width: 40%">Branch Date</div>
        <div>{{ orderData.branch_delivery_date | moment('YYYY-MM-DD hh:mm A') }}</div>
      </div>

      <div
        v-if="orderData.deliver_date"
        class="d-flex my-1"
      >
        <div style="width: 40%">Customer Date</div>
        <div>{{ orderData.deliver_date | moment('YYYY-MM-DD hh:mm A') }}</div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  props: ['orderData'],

  methods: {
    getDate(order) {
      if (order.status_id_fk === 1) {
        return order.order_date ? order.order_date : order.created_at
      }

      if (order.status_id_fk === 2) return order.process_date

      if (order.status_id_fk === 3 || order.is_canceled === '1') return order.cancel_date

      if (order.status_id_fk === 4) return order.confirm_date

      if (order.status_id_fk === 5) return order.refund_date

      if (order.status_id_fk === 6) return order.purchase_date

      if (order.status_id_fk === 7) return order.warehouse_deliver_date

      if (order.status_id_fk === 8) return order.int_shipment_date

      if (order.status_id_fk === 9) return order.branch_delivery_date

      if (order.status_id_fk === 10) return order.deliver_date

      if (order.status_id_fk === 12) return order.order_date

      if (order.status_id_fk === 13) return order.pending_to_branch_at
    }
  }
}
</script>

<style>
.date-container {
  position: relative;
}

.date-container:hover .date-content {
  visibility: visible;
  opacity: 1;
}

.date-content {
  visibility: hidden;
  opacity: 0;
  transition: all 0.3 linear;
  position: absolute;
  top: -10px;
  right: 130px;
  z-index: 1000;
  background-color: #fff;
  border: 1px solid #e4e7ed;
  border-radius: 6px !important;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  padding: 8px 12px;
  width: 270px;
}

.popover-arrow {
  position: absolute;
  top: 25px;
  right: -7px;
  z-index: 3000;
  height: 13px;
  width: 13px;
  border-radius: 0px;
  border: 1px solid #e4e7ed;
  background: #fff;
  transform: rotate(135deg);
  border-bottom: none;
  border-right: none;
}
</style>



// WEBPACK FOOTER //
// src/components/viewOrderDates.vue